import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosFFPassagens = {
    ...dadosAgenciaComum,
    id: 'ffpassagens',
    nome: 'FF Passagens',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-KFNJHGM']
};
